import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import { environment } from "environments/environment";
import { map, retry } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private readonly authBaseUrl = `${environment.BASE_URL}/cmp-auth/v2/auth`;
  constructor(
    private http: HttpClient,
    private router: Router,
    private appStorage: AppLocalStorage,
  ) {}

  loginUser = (loginDetails) =>
    this.http.post(`${this.authBaseUrl}/login`, loginDetails).pipe(
      map((res) => {
        this.setSession(res);
        return res;
      }),
    );

  logOut() {
    sessionStorage.clear();
    sessionStorage.clear();
    this.deleteSession("token");
    this.deleteSession("role");
    // this.router.navigateByUrl('/auth/login');
  }

  resetPassword = (payload) =>
    this.http
      .post(`${this.authBaseUrl}/reset-password`, payload)
      .pipe(retry(3));
  forgotPassword = (email, source) =>
    this.http
      .post(`${this.authBaseUrl}/forgot-password`, { email, source })
      .pipe(retry(3));
  changePassword = (email, param) =>
    this.http
      .post(`${this.authBaseUrl}/changePassword/${email}`, param)
      .pipe(retry(3));
  // getAuthUserInfo = () => this.http.get(`${environment.SERVER_URL}/user/details`).pipe(retry(3))

  getUserRole() {
    return this.appStorage.getFromStorage("user")?.role;
  }

  getUserDetails() {
    return this.appStorage.getFromStorage("user");
  }

  setSession(val) {
    sessionStorage.setItem("access_token", val?.token);
    this.appStorage.storeToStorage("user", val);
  }

  private verifyAccessToken() {
    const tk = { token: sessionStorage.getItem("access_token") };
    return this.http
      .post<boolean>(`${environment.SERVER_URL}/auth/verify`, tk)
      .pipe(
        map((res) => {
          if (res) {
            return true;
          }
        }),
      );
  }

  refreshToken() {
    return this.http.get(`${this.authBaseUrl}/refresh-token`).pipe(
      map((res) => {
        this.setSession(res);
        return res;
      }),
    );
  }

  private deleteSession(key) {
    sessionStorage.removeItem(key);
  }
}
